import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../authentication/authentication.service";

@Injectable({
  providedIn: "root",
})
export class ErrorInterceptorService implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private router: Router) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((errResponse: HttpErrorResponse) => {
        const message = errResponse.error?.message || errResponse.error?.errors?.[0]?.message;
        if (!(errResponse.error instanceof ErrorEvent)) {
          // handle server-side error
          const excludeErrors = [401, 403, 404, 422];
          if (environment.sentryEnable && excludeErrors.includes(errResponse.status) === false) {
            Sentry.setContext("Body", request.body);
            Sentry.setExtras({ error: errResponse });
            Sentry.captureMessage(`${errResponse.message} - ${errResponse.error?.message}`);
          }
          if (
            errResponse.status === 401 &&
            !request.url.includes("/login") &&
            !request.url.includes("/change-password") &&
            !request.url.includes("/users/confirm")
          ) {
            // auto-logout if 401 response returned from api
            this.authenticationService.logout();
            location.reload();
          }
        }
        return throwError(message);
      }),
    );
  }
}
